<div class="min-vh-100 min-vw-100 flex justify-content-center align-items-center not-found-container">
  <div class="h-100 flex flex-column justify-content-center align-content-center">
    <div class="flex flex-row justify-content-center align-content-center w-100">
      <div class="number">4</div>
      <div class="illustration">
        <div class="circle"></div>
        <div class="clip">
          <div class="paper">
            <div class="face">
              <div class="eyes">
                <div class="eye eye-left"></div>
                <div class="eye eye-right"></div>
              </div>
              <div class="rosyCheeks rosyCheeks-left"></div>
              <div class="rosyCheeks rosyCheeks-right"></div>
              <div class="mouth"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="number">4</div>
    </div>
    <div class="not-found-text">Oops. The page you're looking for doesn't exist.</div>
    <button type="button" (click)="goToHome()" class="btn btn-primary mt-5 go-home-btn" style="width: fit-content; align-self: center;">Come Home</button>
  </div>
</div>
